import { Subscription } from "rxjs";

import { Component, OnInit, OnDestroy, Injector, ComponentFactoryResolver, ApplicationRef, ComponentRef } from "@angular/core";
import swal from "bootstrap-sweetalert";

import { Marker, MarkerOptions } from "leaflet";
import { ServiceObject } from "../../../models/serviceObject";
import { Location } from "../../../models/location";
import { ServiceObjectPopupComponent } from "./popup/service-object-popup.component";
import { LocationService } from "app/services/location.service";

import 'leaflet';
import 'leaflet.markercluster';
import * as _ from 'lodash';

import * as L from 'leaflet';
import { MarkerCluster } from "leaflet";

@Component({
  templateUrl: './service-object-map.component.html',
  styleUrls: ['./service-object-map.component.scss']
})
export class ServiceObjectMapComponent implements OnInit, OnDestroy {

  private _attachedComponents: Array<ComponentRef<any>> = [];
  private _currentMapMode: string = "OpenCall";

  constructor(
    private _locationService: LocationService,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _appRef: ApplicationRef,
  ) { }

  private _errorState: ServiceObjectMapComponent.ErrorState = ServiceObjectMapComponent.ErrorState.None;
  private _loadingSubscription: Subscription = null;
  private _locationsIdsOpenCallsSubscription: Subscription = null;
  private _locationsIdsPlannedServiceSubscription: Subscription = null;

  private _map: L.Map = null;
  private _markersLayer: L.LayerGroup = null;
  private _locations: Array<Location> = [];
  private _locationsOpenCallIds: Array<number> = [];
  private _locationsPlannedServiceIds: Array<number> = [];

  ngOnInit(): void {
    this.loadData();
  }

  ngOnDestroy(): void {
    if (this._loadingSubscription)
      this._loadingSubscription.unsubscribe();
    if (this._locationsIdsOpenCallsSubscription)
      this._locationsIdsOpenCallsSubscription.unsubscribe();
    if (this._locationsIdsPlannedServiceSubscription)
      this._locationsIdsPlannedServiceSubscription.unsubscribe();
    this._loadingSubscription = null;
    this._locationsIdsOpenCallsSubscription = null;
    this._locationsIdsPlannedServiceSubscription = null;
    swal.close();

    this._attachedComponents.forEach(componentRef => {
      componentRef.destroy();
    });
  }

  private onMapChanged(map: L.Map): void {
    this._map = map;
    this.attachMarkersLayer();
  }

  private attachMarkersLayer(): void {
    if (this._map && this._markersLayer) {
      if (!this._map.hasLayer(this._markersLayer)) {
        this._markersLayer.addTo(this._map);

        let bounds = new L.LatLngBounds([]);
        this._markersLayer.eachLayer(layer => {
          if (layer instanceof L.MarkerClusterGroup) {
            bounds.extend(layer.getBounds());
          }
        });

        if (bounds.isValid())
          this._map.flyToBounds(bounds, { animate: true, duration: 1.5, paddingTopLeft: [80, 32], paddingBottomRight: [32, 0] });
      }
    }
  }

  private loadData(): void {
    if (this._loadingSubscription)
      this._loadingSubscription.unsubscribe();

    if (this._locationsIdsOpenCallsSubscription)
      this._locationsIdsOpenCallsSubscription.unsubscribe();

    if (this._locationsIdsPlannedServiceSubscription)
      this._locationsIdsPlannedServiceSubscription.unsubscribe();

    if (this._markersLayer)
      this._markersLayer.removeFrom(this._map);
    this._markersLayer = null;
    this._errorState = ServiceObjectMapComponent.ErrorState.None;

    this._locationsIdsOpenCallsSubscription = this._locationService.getLocationsIdsWithOpenCall()
      .finally(() => {
        this._locationsIdsOpenCallsSubscription = null;
      })
      .subscribe(x => {
        this._locationsOpenCallIds = x;

        this._locationsIdsPlannedServiceSubscription = this._locationService.getLocationsIdsWithPlannedService()
          .finally(() => {
            this._locationsIdsPlannedServiceSubscription = null;
          })
          .subscribe(x => {
            this._locationsPlannedServiceIds = x;
            this._loadingSubscription = this._locationService.getLocationsForMap()
              .finally(() => {
                this._loadingSubscription = null;
              })
              .subscribe(x => {
                this._locations = x;
                this.drawMarkers();
              }, err => {
                this._errorState = ServiceObjectMapComponent.ErrorState.UnknownError;

                swal({
                  title: 'Ошибка',
                  text: 'Не удалось получить данные объектов обслуживания. Попробуйте снова',
                  type: 'error',
                  confirmButtonText: 'Попробовать еще раз'
                }, () => {
                  this.loadData();
                });
              });
          }, err => {
            this._errorState = ServiceObjectMapComponent.ErrorState.UnknownError;

            swal({
              title: 'Ошибка',
              text: 'Не удалось получить данные плановых обслуживаниях на локациях. Попробуйте снова',
              type: 'error',
              confirmButtonText: 'Попробовать еще раз'
            }, () => {
              this.loadData();
            });
          });

      }, err => {
        this._errorState = ServiceObjectMapComponent.ErrorState.UnknownError;

        swal({
          title: 'Ошибка',
          text: 'Не удалось получить данные об открытых обращениях. Попробуйте снова',
          type: 'error',
          confirmButtonText: 'Попробовать еще раз'
        }, () => {
          this.loadData();
        });
      });
  }

  private drawMarkers() {
    if (this._markersLayer)
      this._markersLayer.clearLayers();

    let markersLayer = L.layerGroup([]);

    var self = this;
    let markerClusterGroup = L.markerClusterGroup(
      {
        iconCreateFunction: function (cluster: MarkerCluster) {
          var childCount = cluster.getChildCount();
          var clusterMarkers = cluster.getAllChildMarkers();

          var className = "marker-cluster-default";

          if (self._currentMapMode == "OpenCall") {
            var hasOpenCalls = _.some(clusterMarkers, function (marker) {
              var markerOptions = marker.options as OpenCallMarkerOptions;
              return markerOptions.hasOpenCalls;
            });

            className = (hasOpenCalls) ? 'marker-cluster-hasOpenCalls' : "marker-cluster-noOpenCalls";
          } else if (self._currentMapMode == "PlannedPlannedService") {
            var hasPlannedPlannedService = _.some(clusterMarkers, function (marker) {
              var markerOptions = marker.options as PlannedPlannedServiceMarkerOptions;
              return markerOptions.hasPlannedPlannedService;
            });

            className = (hasPlannedPlannedService) ? 'marker-cluster-hasPlannedPlannedServices' : "marker-cluster-noPlannedPlannedServices";
          }

          return new L.DivIcon({ html: '<div><span>' + childCount + '</span></div>', className: 'marker-cluster ' + className, iconSize: new L.Point(40, 40) });
        }
      }
    ).addTo(markersLayer);
    const compFactory = this._componentFactoryResolver.resolveComponentFactory(ServiceObjectPopupComponent);

    markerClusterGroup.on('spiderfied', function (event) {
      var cluster = event['cluster'];
      // Center the map on the clicked cluster if it gets spiderfied.
      if (cluster != null)
        this._map.panTo(cluster.getLatLng());
    });

    this._locations.forEach(serviceObject => {
      if (typeof serviceObject.latitude === "number" && typeof serviceObject.longitude === "number") {
        let location: [number, number] = [serviceObject.latitude, serviceObject.longitude];
        let popupComponentRef: ComponentRef<ServiceObjectPopupComponent> = null;

        var options: MarkerOptions = {};

        if (this._currentMapMode == "OpenCall") {
          options = this._locationsOpenCallIds.indexOf(serviceObject.id) > -1 ? markerHasOpenCallsOptions : markerNoOpenCallsOptions;
        } else if (this._currentMapMode == "PlannedPlannedService") {
          options = this._locationsPlannedServiceIds.indexOf(serviceObject.id) > -1 ? markerHasPlannedPlannedServicesOptions : markerNoPlannedPlannedServicesOptions;
        }

        L.marker(location, options)
          .bindPopup(layer => {
            popupComponentRef = compFactory.create(this._injector);
            popupComponentRef.instance.serviceObject = serviceObject;
            popupComponentRef.changeDetectorRef.detectChanges();
            this._appRef.attachView(popupComponentRef.hostView);

            popupComponentRef.onDestroy(() => {
              let index = this._attachedComponents.indexOf(popupComponentRef);
              this._attachedComponents.splice(index, 1);
            });
            this._attachedComponents.push(popupComponentRef);

            return popupComponentRef.location.nativeElement;
          })
          .on('popupclose ', event => {
            if (popupComponentRef)
              popupComponentRef.destroy();
            popupComponentRef = null;
          })
          .addTo(markerClusterGroup);
      }
    });
    this._markersLayer = markersLayer;
    this.attachMarkersLayer();
  }

  private ErrorStateEnum = ServiceObjectMapComponent.ErrorState;
}

export namespace ServiceObjectMapComponent {

  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Другая ошибка при получении данных с сервера
     */
    UnknownError
  }
}

interface OpenCallMarkerOptions extends MarkerOptions {
  hasOpenCalls: boolean;
}

interface PlannedPlannedServiceMarkerOptions extends MarkerOptions {
  hasPlannedPlannedService: boolean;
}

const markerNoOpenCallsOptions: OpenCallMarkerOptions = {
  clickable: false,
  draggable: false,
  hasOpenCalls: false,
  icon: L.icon({
    iconUrl: 'assets/map/marker-no-open-calls.svg',
    iconSize: [32, 32],
    iconAnchor: [15, 31]
  })
};

const markerHasOpenCallsOptions: OpenCallMarkerOptions = {
  clickable: false,
  draggable: false,
  hasOpenCalls: true,
  icon: L.icon({
    iconUrl: 'assets/map/marker-has-open-calls.svg',
    iconSize: [32, 32],
    iconAnchor: [15, 31]
  })
};

const markerHasPlannedPlannedServicesOptions: PlannedPlannedServiceMarkerOptions = {
  clickable: false,
  draggable: false,
  hasPlannedPlannedService: true,
  icon: L.icon({
    iconUrl: 'assets/map/marker-has-planned-plannedServices.svg',
    iconSize: [32, 32],
    iconAnchor: [15, 31]
  })
};

const markerNoPlannedPlannedServicesOptions: PlannedPlannedServiceMarkerOptions = {
  clickable: false,
  draggable: false,
  hasPlannedPlannedService: false,
  icon: L.icon({
    iconUrl: 'assets/map/marker-no-planned-plannedServices.svg',
    iconSize: [32, 32],
    iconAnchor: [15, 31]
  })
};



// WEBPACK FOOTER //
// /app/SPA/src/app/client/serviceObject/map/service-object-map.component.ts